import React, { useCallback } from 'react';

import { useModalStore, useAdobeTarget } from 'bdvp-common/src/hooks/store';
import { useMediaConfig } from 'bdvp-common/src/hooks/config';

import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useSelectedFiltersStore from '../hooks/store/useSelectedFiltersStore';
import useFieldsQuery from '../hooks/store/useFieldsQuery';
import useFiltersConfig from '../hooks/useFiltersConfig';
import { FILTER_LAYOUT } from '../utils/constants';

/** For dev purposes, to be removed */
import { useLocation } from 'react-router-dom';
/** end */

import Component from '../components/FilterPanel';

const { FILTER_MODAL_NAME } = modalConstants;

const FilterPanel = () => {

    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.search) ?? {};

    const {
        payload: isFreeTextSearchEnabled = false,
        loading: isTargetOfferLoading,
        enabled: testEnabled,
    } = useAdobeTarget(config.adobeTarget, 'freeTextSearch');

    let {
        payload: filterLayout = FILTER_LAYOUT.tabs,
        loading: isTargetOfferLoadingFilterLayout,
        enabled: testEnabledFilterLayout,
    } = useAdobeTarget(config.adobeTarget, 'filterLayout');

    /** For dev purposes, to be removed */
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('fl')) {

        filterLayout = urlParams.get('fl');

    }
    /** end */

    const {
        selectedFilters,
        clearFilters,
        applyFilters,
        resetFilters,
        removeSelectedFilter,
        addSelectedFilter,
        setFilters,
    } = useSelectedFiltersStore();
    const {
        fieldsIds = {},
        filtersConfig,
        loading: isFilterConfigLoading,
    } = useFiltersConfig();
    const {
        loadFields,
        called,
        loading,
        data,
    } = useFieldsQuery(fieldsIds.withValues, fieldsIds.withoutValues);
    const {
        modalHide,
    } = useModalStore();
    const closeFilterModal = useCallback(() => modalHide(FILTER_MODAL_NAME), [modalHide]);

    if(
        (testEnabled && isTargetOfferLoading)
        || isFilterConfigLoading
        || (isTargetOfferLoadingFilterLayout && testEnabledFilterLayout)
    ) {

        return null;

    }

    return (
        <Component
            loadFields={loadFields}
            loading={!called || loading}
            data={data}
            selectedFilters={selectedFilters || []}
            removeSelectedFilter={removeSelectedFilter}
            addSelectedFilter={addSelectedFilter}
            clearFilters={clearFilters}
            applyFilters={applyFilters}
            resetFilters={resetFilters}
            closeFilterModal={closeFilterModal}
            setFilters={setFilters}
            isFreeTextSearchEnabled={isFreeTextSearchEnabled}
            filtersConfig={filtersConfig}
            filterLayout={filterLayout}
        />
    );

};

export default FilterPanel;
